<template>
  <div>
    <v-data-table
      v-bind="attributesTable.dataTable"
      :item-key="attributesTable.keyValue"
      :expanded.sync="expanded"
      :page.sync="currentPage"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      :footer-props="{ itemsPerPageOptions }"
      v-model="selected"
      @item-selected="selectItem"
      @current-items="currentItems = $event"
      @page-count="pageCount = $event"
      :class="['v-data-table__custom  elevation-2', attributesTable.dataTable.expandAll && 'v-data-table__custom-header-editable']"
    >
      <template v-slot:top v-if="attributesTable.showSearch">
        <v-card-title class="pt-1 elevation-0">
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisar"
            single-line
            hide-details
            id="input-search"
          ></v-text-field>
        </v-card-title>
      </template>

      <template v-if="loading" v-slot:progress>
        <v-progress-linear color="error" :height="6" indeterminate></v-progress-linear>
      </template>

      <template v-slot:item.action="{ item }">
        <v-layout justify-space-between>
          <v-icon
            small
            color="primary"
            @click="edit(item)"
            :id="`edit-table-${item[attributesTable.keyValue]}`"
          >{{ attributesTable.editIcon }}</v-icon>

          <template v-if="actions.length > 0">
            <v-icon
              small
              v-for="(action, key) in actions"
              v-bind="action.attributesIcon"
              :key="key"
              @click="executeAction(action, 'list', item)"
              :id="`${action.id}-${item[attributesTable.keyValue]}`"
              :name="`${action.name}-${item[attributesTable.keyValue]}`"
              v-tooltip.bottom="{ content: action.tooltip, classes: action.tooltipColorClass }"
            >{{ action.attributesIcon.icon }}</v-icon>
          </template>
        </v-layout>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-icon
            v-if="!attributesTable.dataTable.expandAll"
            class="v-icon--close"
            small
            @click="handleCloseExpandedItem(item)"
          >close</v-icon>

          <v-layout row class="mb-0 mt-0">
            <v-col sm="11" cols="12" class="p-0 pt-2">
              <vue-form-generator
                tag="div"
                v-if="schemaFields"
                :schema="{ fields: schemaFieldsSelected(item) }"
                :options="{ mode: 'list', page, item, index: getIndex(item), items: currentItems }"
                :model="getItemModify(item)"
              />
            </v-col>
            <v-col sm="1" cols="12" class="action-col p-0 pt-2">
              <v-icon
                small
                v-for="(action, key) in conditioningsActions(item)"
                v-bind="action.attributesIcon"
                :key="key"
                @click="executeAction(action, 'list', item)"
                :id="`${action.id}-${item[attributesTable.keyValue]}`"
                :name="`${action.name}-${item[attributesTable.keyValue]}`"
                v-tooltip.bottom="{ content: action.tooltip, classes: action.tooltipColorClass }"
              >{{ action.attributesIcon.icon }}</v-icon>
            </v-col>
          </v-layout>
        </td>
      </template>
    </v-data-table>

    <div v-if="attributesTable.dataTable.externalPagination" class="text-center pt-2">
      <v-pagination v-model="currentPage" :length="pageCount"></v-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Swal from 'sweetalert2';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  props: {
    page: { type: String },
    items: { type: Array, default: () => [] },
    schema: { Type: Object, default: () => ({}) },
    headers: { Type: Object, default: () => ({}) },
    initialItems: { type: Array, default: () => [] },
    lookupwindow: { type: Boolean, default: false }
  },

  data: () => ({
    selected: [],
    expanded: [],
    search: '',
    loading: false,
    currentPage: 1,
    lastPage: 0,
    pageCount: 0,
    currentItems: [],
    initTable: false
  }),

  created() {
    this.attributesTable.dataTable.expandAll && (this.expanded = this.initialItems);
  },

  computed: {
    attributesTable() {
      return this.lookupwindow ? this.schema : this.schema.attributes.attributesTable;
    },

    actions() {
      return this.schema.recordActionsModel || [];
    },

    schemaFields() {
      return this.schema.lookups;
    },

    isEditable() {
      return 'fields' in this.schema;
    },

    hasInlineConditions() {
      return this.schema.inlineConditions.length > 0 ? true : false;
    },

    itemsPerPageOptions() {
      return 'itemsPerPageOptions' in this.attributesTable
        ? this.attributesTable.itemsPerPageOptions
        : [
            {
              text: '4',
              value: 4
            },
            {
              text: '8',
              value: 8
            },
            {
              text: '16',
              value: 16
            },
            {
              text: '32',
              value: 32
            },
            {
              text: '100',
              value: 100
            },
            {
              text: 'Todos',
              value: -1
            }
          ];
    },

    itensLenght() {
      return this.items.length;
    }
  },

  methods: {
    edit(item) {
      this.$emit('edit-item', { item, mode: this.attributesTable.editMode, origin: 'list' });
    },

    getItemModify(item) {
      return this.initialItems.find(x => x[this.attributesTable.keyValue] === item[this.attributesTable.keyValue]);
    },

    formatHeader() {
      return this.dataHeaders.filter(el => el.text !== '');
    },

    conditioningsActions(i) {
      if (this.lookupwindow || !this.schema.recordActionsModel.length) return;
      const key = i[this.schema.attributes.attributesTable.keyValue];
      const actions = this.$store.getters['page/actions']({ page: this.page, key });

      if (actions) {
        return actions.filter(x => x.visible);
      } else {
        return;
      }
    },

    getIndex(item) {
      let index;
      const key = this.schema.attributes.attributesTable.keyValue;

      this.items.forEach((field, i) => {
        if (field[key] == item[key]) {
          index = i;
        }
      });

      return index;
    },

    schemaFieldsSelected(item) {
      return this.schemaFields[item[this.attributesTable.keyValue]];
    },

    formatDate: v => moment(v).format('DD/MM/YYYY'),

    selectItem({ item, value }) {
      this.$emit('select-item', item);
      if (this.lookupwindow) this.selected = [];
    },

    handleCloseExpandedItem(item) {
      this.expanded = this.expanded.filter(el => el[this.attributesTable.keyValue] !== item[this.attributesTable.keyValue]);
      this.$emit('close-expanded');
    },

    executeAction(action, origin, model) {
      if (action.confirmMessage) {
        this.confirmDialog(action, origin, model);
      } else {
        this.action(action, origin, model);
      }
    },

    async action(action, origin, model) {
      this.$store.dispatch('page/executeAction', {
        page: this.page,
        mode: 'list',
        origin,
        action,
        model,
        index: this.getIndex(model)
      });
    },

    confirmDialog(action, origin, model) {
      const {
        title,
        text,
        icon,
        showCancelButton,
        confirmButtonText,
        cancelButtonText,
        reverseButtons,
        confirmButtonClass,
        cancelButtonClass
      } = action.confirmMessage;

      let defaultClassConfirm = confirmButtonClass || 'primary';
      let defaultClassCancel = cancelButtonClass || 'error';

      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: `v-btn v-size--default ${defaultClassConfirm}`,
          cancelButton: `v-btn v-size--default error ${defaultClassCancel}`
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title,
          text,
          icon,
          showCancelButton,
          confirmButtonText,
          cancelButtonText,
          reverseButtons
        })
        .then(result => {
          if (result.value) this.action(action, origin, model);
        });
    }
  },

  watch: {
    itensLenght(newValue) {
      this.attributesTable.dataTable.expandAll && (this.expanded = this.items);
    },
    selected(newValue) {
      if (this.lookupwindow) return;

      let initialItems = this.initialItems;

      let keyValue = this.schema.attributes.attributesTable.keyValue;

      const selectedItems = this.initialItems.filter(item =>
        newValue.find(x => {
          if (x[keyValue] === item[keyValue]) return item;
        })
      );
      this.$store.dispatch('page/updateSelectedItems', { selectedItems, keyValue });
    },

    async currentItems(items, old) {
      if (!items.length) return;
      if (this.lookupwindow) return;

      if (this.isEditable) {
        await this.$store.dispatch('page/setLookupListScheme', this.page);
        await this.$store.dispatch('page/loadLookupsList', { items, page: this.page });
        this.attributesTable.dataTable.expandAll && (this.expanded = items);
      }

      await this.$store.dispatch('page/setActionsCondition', this.page);
      await this.$store.dispatch('page/initInlineConditionsList', { page: this.page, mode: 'list', items });
      await this.$store.dispatch('page/initConditionsList', {
        page: this.page,
        mode: 'list',
        items,
        key: this.schema.attributes.attributesTable.keyValue
      });

      this.lastPage = this.currentPage;
      return;
    },

    items() {
      this.selected = [];
    }
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 598px) {
  .v-data-table__wrapper {
    table {
      tr {
        display: flex;
      }
    }
  }
}
.action-col {
  margin: auto auto;
  button {
    margin-left: 10px;
  }
}
</style>
